import _ from 'lodash';
import Service from './abstract';

const defaultOptions = {
    order: 'created_at-DESC',
};

class FraudPrevention extends Service {
    constructor () {
        super('users/fraudcontrol');
    }

    getRules (options) {
        return this.get({
            url: `${this.basePath}/rules`,
            qs: _.defaultsDeep(options, defaultOptions)
        });
    }
}

export default new FraudPrevention();
